<template>
  <BreadCrumb PageTitle="Profile Settings" />
  <ProfileSettings />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import ProfileSettings from "../../template-components/Social/ProfileSettings/ProfileSettings.vue";

export default defineComponent({
  name: "ProfileSettingsPage",
  components: {
    BreadCrumb,
    ProfileSettings,
  },
});
</script>